import Tabby from "tabbyjs";

/**
 * Logic behind doctors page
 * Content of each doctor is hidden and shown like tabs
 */
export default class DoctorsTabs {
    constructor() {
        this.DOM = {
            doctorsTabs: ".js-doctors-tabs",
            states: {
                active: "is-active",
            },
        };

        /**
         * Fetch doctors tabs HTML element
         * @type {Element}
         */
        this.doctorsTabs = document.querySelector(this.DOM.doctorsTabs);
    }

    init() {
        if (this.doctorsTabs === null) {
            return;
        }
        this.tabbyJS();
    }

    tabbyJS() {
        new Tabby(this.DOM.doctorsTabs);
        let activeTab = this.doctorsTabs.querySelector("[aria-selected=true]");
        activeTab.classList.add(this.DOM.states.active);
        document.addEventListener(
            "tabby",
            (event) => {
                activeTab.classList.remove(this.DOM.states.active);
                activeTab = event.target;
                activeTab.classList.add(this.DOM.states.active);
            },
            false,
        );
    }
}
